// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  urlSSO: 'https://rest.apps4beyond.com/v2/',
  urlTO: 'https://apps4beyond.com/REST/TeOrientaTest/',
  urlPerformance: 'https://apps4beyond.com/REST/Performance/'
  //  URLS DE DESARROLLO (LOCAL)
  // urlSSO: 'http://localhost:8080/4beyond2/sso-back/',
  // urlTO: 'http://localhost:8080/4beyond2/forbeyondservices/TeOrienta/',
  // urlPerformance: 'http://localhost:8080/4beyond2/forbeyondservices/Performance/'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
